import { Component, EventEmitter, OnInit } from '@angular/core';
import { PublicidadService } from '../publicidad.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { PublicidadCreateComponent } from '../publicidad-create/publicidad-create.component';
import { PublicidadViewComponent } from '../publicidad-view/publicidad-view.component';
import { PublicidadUpdateComponent } from '../publicidad-update/publicidad-update.component';
import { saveAs } from 'file-saver';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';

@Component({
  selector: 'app-publicidad-index',
  templateUrl: './publicidad-index.component.html',
  styleUrls: ['./publicidad-index.component.scss']
})
export class PublicidadIndexComponent implements OnInit {

  get url(): string { return this.config.apiUrl + this.service.controller + ''; };
  get excel(): string { return this.config.apiUrl + this.service.controller + 'excel'; };
  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Desde (Subida)',
      column: 'fecha_subida',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta  (Subida)',
      column: 'fecha_subida',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Título',
      column: 'titulo',
      op: 'like',
    },
    {
      label: 'URL',
      column: 'url',
      op: 'like',
    },
    {
      label: 'Tipo',
      column: 'tipo',
      op: 'like',
      type: 'select',
      options: [
        {
          label: "Banner",
          value: '1'
        },
        {
          label: "PopUp",
          value: '2'
        },
      ],
    },
    {
      label: 'Estado',
      column: 'tipo',
      op: 'like',
      type: 'select',
      options: [
        {
          label: "Activado",
          value: '1'
        },
        {
          label: "Desactivado",
          value: '0'
        },
      ],
    }
  ];

  acciones = [
    {
      label: 'Ver',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element);
      }
    },
    {
      icon: "download",
      label: "Descargar",
      action: (element: any, index: number) => {
        this.download(element);
      },
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.edit(element)
      }
    },
    {
      icon: "toggle-on",
      label: "Activar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 0;
      }
    },
    {
      icon: "toggle-off",
      label: "Desactivar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1;
      }
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any, index: number) => {
        this.delete(element);
      },
      hide: (element: any, index: number) => {
        return element.rol_id > 2;
      }
    },
  ]

  columnas = [
    {
      label: 'Fecha Subida',
      attribute: 'fecha_subida',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        return this.formatter.dateFormat(element.fecha_subida);
      }
    },
    {
      label: 'Título',
      attribute: 'titulo',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any, index: number) => {
        return element.titulo;
      }
    },
    {
      label: 'Descripción',
      attribute: 'descripcion',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any, index: number) => {
        return element.descripcion;
      }
    },
    {
      label: 'Tipo',
      attribute: 'tipo',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        if (element.tipo == 1) return 'Banner';
        if (element.tipo == 2) return 'PopUp';
        return '';
      }
    },
    {
      label: 'URL',
      attribute: 'url',
      width: 1,
      responsive: ['SM', 'MD'],
      styled: true,
      value: (element: any, index: number) => {
        if (!element.url) return '';
        return `<a href="${element.url}">${element.url}</a>`;
      }
    },
  ];

  constructor(
    private config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: PublicidadService,
    public sesion: SesionService,
    public formatter: FormatterService
  ) { }

  ngOnInit(): void { }

  loadData(): void {
    this.reloadEmitter.emit();
  }

  add(): void {
    const modalRef = this.modalService.open(PublicidadCreateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  async view(element: any): Promise<void> {
    const result = await this.getElement(element);
    if(!result) return;
    const modalRef = this.modalService.open(PublicidadViewComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true });
    modalRef.componentInstance.element = result;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  async edit(element: any): Promise<void> {
    const result = await this.getElement(element);
    if(!result) return;
    const modalRef = this.modalService.open(PublicidadUpdateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = result;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  download(element: any): void {
    this.loading.show();
    this.service.downloadFile(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        saveAs(res, `${element.nombre_publicidad}.${element.extension_publicidad}`);
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo descargar el archivo.", "danger");
      }
    });
  }

  getElement(element: any): Promise<any> {
    this.loading.show();
  
    return new Promise((resolve, reject) => {
      this.service.view(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          resolve(res);
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de publicidad.", "danger");
          reject(err);
        }
      });
    });
  }
  

  getElement1(element: any): any {
    this.loading.show();
    this.service.view(element).subscribe({
      next: (res) => {
        this.loading.hide();
        return res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el registro de publicidad.", "danger");
        return null;
      }
    });
  }

  toggle(element: any): void {
    if (element.estado == 1) {
      this.loading.show();
      this.service.deactivate(element.id).subscribe({
        next: (res) => {
          this.alerts.addAlert("Se ha desactivado la Publicidad.", "success");
          this.loading.hide();
          this.loadData();
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar la Publicidad.", "danger");
        }
      });
    } else {
      this.loading.show();
      this.service.activate(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.alerts.addAlert("Se ha activado la Publicidad.", "success");
          this.loadData();
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar la Publicidad.", "danger");
        }
      });
    }
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Publicidad';
    modalRef.componentInstance.texto = ` '¿Seguro que desea eliminar la Publicidad ${element.titulo}?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Usuario eliminado con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro de cliente.", "danger");
        }
      });
    }, (reason) => { });
  }

}
